// removed by extract-text-webpack-plugin
module.exports = {"banner":"_2APR","col1":"_2upO","col2":"_28fm","hideCol":"IHPe","downloadCsv":"_2xcI"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/CallAnalytics/CallAnalytics.scss
// module id = ghWR
// module chunks = 0